import { IdentityType, IIdentity } from 'types';
import { formatMobile } from './strings';

/**
 * finds the first identity in the array that matches the identity-type
 *
 * @param identities - an array of IIdentity objects
 * @param type - an IdentityType
 * @returns - an IIdentity object
 */
export const getIdentityByType = (identities: IIdentity[], type: IdentityType) => identities?.find((identity) => identity.type === type);

/**
 * finds the first identity in the array that matches the identity type and the identity value
 *
 * @param identities - an array of IIdentity objects
 * @param type - an IdentityType
 * @param value - a string representing the identity value to match
 * @returns - an IIdentity object
 */
export const findIdentityByValue = (identities: IIdentity[], type: IdentityType, value: string) => identities?.find((identity) => identity.type === type && identity.value === value);

/**
 * checks if IdentityType is mobile and formats that value for UI display, otherwise returns the raw `value` (email)
 *
 * @param identity - an IIdentity object
 * @returns - a formatted mobile string or email string
 */
export const formatIdentityForUI = (identity: IIdentity) => identity && (identity.type === IdentityType.MOBILE ? formatMobile(identity.value) : identity.value);

/**
 * checks if at least one specified IdentityType has been verified in an array of IIdentity objects
 *
 * @param identities - an array of IIdentity objects
 * @param type - an IdentityType to check verification status
 * @returns - boolean
 */
export const hasVerifiedIdentityType = (identities: IIdentity[], type: IdentityType) => identities?.some((identity) => identity.verified && identity.type === type);
